import useServerTime from './useServerTime.js';

export default function DigitalClock({ axiosInstance }) {
  const time = useServerTime(axiosInstance);

  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;

  const pad = (n) => n.toString().padStart(2, '0');

  const dateStr = time.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-baseline gap-0.5 font-mono">
        <span className="text-xl font-semibold tracking-wider" style={{ color: 'var(--nad-t1)' }}>
          {pad(displayHours)}
        </span>
        <span className="text-xl font-semibold animate-pulse" style={{ color: 'var(--nad-accent-txt)' }}>:</span>
        <span className="text-xl font-semibold tracking-wider" style={{ color: 'var(--nad-t1)' }}>
          {pad(minutes)}
        </span>
        <span className="text-xl font-semibold animate-pulse" style={{ color: 'var(--nad-accent-txt)' }}>:</span>
        <span className="text-xl font-semibold tracking-wider" style={{ color: 'var(--nad-t2)' }}>
          {pad(seconds)}
        </span>
        <span className="text-[10px] font-bold ml-1 self-start mt-1" style={{ color: 'var(--nad-accent-txt)' }}>
          {ampm}
        </span>
      </div>
      <p className="text-[10px] tracking-wide mt-0.5" style={{ color: 'var(--nad-t3)' }}>{dateStr}</p>
    </div>
  );
}
